import { render, staticRenderFns } from "./LectureRequestModal.vue?vue&type=template&id=54701c5c&scoped=true&"
import script from "./LectureRequestModal.vue?vue&type=script&lang=js&"
export * from "./LectureRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./LectureRequestModal.vue?vue&type=style&index=0&id=54701c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54701c5c",
  null
  
)

export default component.exports